import React, { useEffect, useState } from 'react';
import { VbzTabBar, ItemListTabs } from '@smiles/voebiz-ui-kit';
import { FormGroup, TabContent, TabPane } from 'reactstrap';
import Collapsible from 'react-collapsible';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import { IContent, ITopic } from '../../@types/faq-topic';
import { VoeBizApi } from '../../services/services';

const FAQ = () => {
  const { t } = useTranslation('faq');
  const [activeTab, setActiveTab] = useState<string>('tab0');
  const [topicList, setTopicList] = useState<ITopic[]>([]);
  const api = VoeBizApi();

  const getTabs = (list: ITopic[]) => {
    const tabList: ItemListTabs[] = [{}];

    list.forEach((topic: ITopic, index) =>
      tabList.push({
        id: `tab${index}`,
        key: `_tab${index}`,
        label: topic.name,
        href: '#',
        active: activeTab === `tab${index}`,
        onClick: () => setActiveTab(`tab${index}`),
      }),
    );

    return tabList;
  };

  const renderTabContents = (list: ITopic[]) => {
    return list.map((topic: ITopic, index) => (
      <TabPane key={v4()} tabId={`tab${index}`} id={`_tab${index}`} className="tab">
        {topic.qa.map((content: IContent) => (
          <>
            <Collapsible key={v4()} trigger={<p>{content.question}</p>} transitionTime={200}>
              <p dangerouslySetInnerHTML={{ __html: content.answer }} />
            </Collapsible>
          </>
        ))}
      </TabPane>
    ));
  };

  useEffect(() => {
    const fetchTopics = async () => {
      const topics: ITopic[] = [];
      const response = await api.getTopics();

      if (response.success) {
        const data = response.response;
        const names = Object.getOwnPropertyNames(data);
        names.forEach((name: string) => {
          const qa: IContent[] = [];

          data[name].forEach((element: any) => {
            const content: IContent = {
              question: element.title,
              answer: element.body,
            };
            qa.push(content);
          });

          const topic: ITopic = { name, qa };
          topics.push(topic);
        });
      }
      setTopicList(topics);
    };
    fetchTopics();
  }, []);

  return (
    <section className="attendance-faq-section">
      <div className="attendance-faq-section__title">{t('topic.title')}</div>
      <>
        <FormGroup>
          <VbzTabBar list={getTabs(topicList)} />
        </FormGroup>
        <TabContent activeTab={activeTab}>{renderTabContents(topicList)}</TabContent>
      </>
    </section>
  );
};

export default FAQ;
